import React from 'react'
import { getChristmasSnowEnabled } from '@/modules/settings/services/christmasSnowFeatureService'

export default function ChristmasSnowLayer() {
  const [enabled, setEnabled] = React.useState<boolean | null>(null)

  React.useEffect(() => {
    let mounted = true
    getChristmasSnowEnabled()
      .then((on) => {
        if (mounted) setEnabled(on)
      })
      .catch(() => {
        if (mounted) setEnabled(false)
      })
    return () => {
      mounted = false
    }
  }, [])

  if (!enabled) return null

  return <div className="christmas-snow-layer" aria-hidden="true" />
}

